/* Smarket theme search — browser glue. Depends on SMKSearchCore (loaded first).
   Spec: docs/specs/2026-09-08-theme-native-search-design.md */
(function () {
  'use strict';
  if (!window.SMKSearchCore) return;

  var CACHE_KEY = 'smk-search-index:v3-stock'; // v2: adds metafield facets (f)
  var TTL = 5 * 60 * 1000;
  var core = null;
  var readyPromise = null;
  var readyAt = 0;

  function readCache() {
    try {
      var raw = window.localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      return (o && Array.isArray(o.items) && o.items.length) ? o : null;
    } catch (e) { return null; }
  }
  function writeCache(items) {
    try { window.localStorage.setItem(CACHE_KEY, JSON.stringify({ fetchedAt: Date.now(), items: items })); } catch (e) { /* quota / private mode */ }
  }
  function parseSection(html) {
    var s = html.indexOf('{'), e = html.lastIndexOf('}');
    if (s === -1 || e === -1) throw new Error('index: no JSON in response');
    return JSON.parse(html.slice(s, e + 1));
  }
  function fetchPage(n) {
    return fetch('/collections/all?section_id=search-index&sort_by=best-selling&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('index page ' + n + ': HTTP ' + r.status); return r.text(); })
      .then(parseSection);
  }
  function fetchAll() {
    return fetchPage(1).then(function (first) {
      var pages = first.pages || 1, rest = [];
      for (var n = 2; n <= pages; n++) rest.push(fetchPage(n));
      return Promise.all(rest).then(function (others) {
        var items = first.items;
        for (var i = 0; i < others.length; i++) items = items.concat(others[i].items);
        return items;
      });
    });
  }
  function ready() {
    if (readyPromise && Date.now() - readyAt < TTL) return readyPromise;
    var cached = readCache();
    if (cached && Date.now() - (cached.fetchedAt || 0) < TTL) {
      core = window.SMKSearchCore.build(cached.items); readyAt = cached.fetchedAt;
      readyPromise = Promise.resolve(core); return readyPromise;
    }
    readyAt = Date.now();
    readyPromise = fetchAll().then(function (items) {
      writeCache(items); core = window.SMKSearchCore.build(items); readyAt = Date.now(); return core;
    }).catch(function (e) { readyPromise = null; throw e; });
    return readyPromise;
  }
  function query(term, opt) { return core ? core.query(term, opt) : null; }

  window.SMKSearch = {
    ready: ready,
    query: query,
    // layout: 'd' compact search card (desktop) | 'm' theme product card (mobile 2-col)
    cardsQuery: function (mode, term, handles, wmd, wxs, layout) {
      var t = String(term || '').replace(/[|,]/g, ' ').trim();
      return mode === 'r'
        ? '__h__:r|' + (layout || 'd') + '|' + (wmd || '3') + '|' + (wxs || '6') + '|' + t + '|' + handles.join(',')
        : '__h__:p|' + t + '|' + handles.join(',');
    },
    fetchCards: function (q) {
      // The predictive endpoint renders the section too, and unlike /search it does not feed
      // Shopify's "Top online store searches" report with our __h__ handle lists.
      return fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=1&section_id=search-cards', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('cards: HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.querySelector('#shopify-section-search-cards');
          if (!sec) throw new Error('cards: section missing');
          return sec.innerHTML;
        });
    },
    track: (function () {
      var last = '';
      return function (term, total) {
        term = String(term || '').trim();
        if (term.length < 2 || term === last) return;
        last = term;
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'search', search_term: term, results: total });
          if (typeof window.clarity === 'function') window.clarity('set', 'search_term', term);
        } catch (e) {}
      };
    })()
  };

  // ---------- Predictive overlay takeover ----------
  var RECENT_KEY = 'smk-search-recent';
  function readRecent() { try { var a = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function pushRecent(term) {
    term = String(term || '').trim(); if (!term) return;
    var a = readRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    a.unshift(term); a = a.slice(0, 5);
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(a)); } catch (e) {}
  }
  function clearRecent() { try { window.localStorage.removeItem(RECENT_KEY); } catch (e) {} }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function noticeHtml(res, i18n) {
    if (res.typo && res.typo.length) {
      var corrected = res.typo.map(function (t) { return t.to; }).join(' ');
      return '<p class="smk-notice">' + escapeHtml((i18n.showing_results_for || 'Showing results for "%s"').replace('%s', corrected)) + '</p>';
    }
    if (res.partial) return '<p class="smk-notice">' + escapeHtml(i18n.no_exact_match || 'No exact match. Showing the closest results.') + '</p>';
    return '';
  }
  var ICON_SEARCH = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';
  function suggestionsHtml(list, i18n) {
    if (!list || !list.length) return '';
    var h = '<div class="smk-suggest-terms" role="listbox" aria-label="' + escapeHtml(i18n.suggestions || 'Suggestions') + '">';
    for (var i = 0; i < list.length; i++) h += '<button type="button" class="smk-suggest-term smk-suggest-term--' + list[i].kind + '" role="option" data-smk-term="' + escapeHtml(list[i].text) + '">' + ICON_SEARCH + '<span>' + escapeHtml(list[i].text) + '</span></button>';
    return h + '</div>';
  }
  function chipsHtml(title, terms, extra) {
    if (!terms.length) return '';
    var h = '<div class="smk-suggest__group"><p class="smk-suggest__title">' + escapeHtml(title) + (extra || '') + '</p><div class="smk-chips">';
    for (var i = 0; i < terms.length; i++) h += '<button type="button" class="smk-chip" data-smk-term="' + escapeHtml(terms[i]) + '">' + escapeHtml(terms[i]) + '</button>';
    return h + '</div></div>';
  }
  // Shopify's `t` filter HTML-escapes quotes inside translations; decode once here.
  function decodeEntities(s) { var ta = document.createElement('textarea'); ta.innerHTML = String(s); return ta.value; }
  function readI18n(el) {
    try {
      var o = JSON.parse(el.getAttribute('data-smk-i18n') || '{}');
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k) && typeof o[k] === 'string') o[k] = decodeEntities(o[k]);
      return o;
    } catch (e) { return {}; }
  }

  function setupPredictive() {
    var Cls = window.customElements && window.customElements.get('sht-predictive-srch');
    if (!Cls) return;
    var proto = Cls.prototype;
    var nativeFetch = proto.fetchResults;

    // Desktop: size the dropdown to the search box instead of the whole header width.
    function positionPanel(el) {
      var panel = el.elms && el.elms.predictive_search_results;
      var input = el.elms && el.elms.predictive_search_input;
      if (!panel || !input) return;
      panel.classList.add('smk-active');
      // The store injects `.ctnr { width:95% !important }` globally, so plain inline
      // styles lose; the CSS rule reads these custom properties with !important instead.
      if (window.matchMedia('(max-width: 768px)').matches) { panel.style.removeProperty('--smk-left'); panel.style.removeProperty('--smk-w'); return; }
      var host = panel.offsetParent || el;
      var ir = input.getBoundingClientRect(), hr = host.getBoundingClientRect();
      panel.style.setProperty('--smk-left', Math.max(0, ir.left - hr.left) + 'px');
      panel.style.setProperty('--smk-w', ir.width + 'px');
    }

    proto.fetchResults = function (term) {
      var self = this;
      var i18n = readI18n(self);
      positionPanel(self);
      self.toggleLoading(true); self.toggleLoadingContainer(true);
      return window.SMKSearch.ready().then(function (core) {
        var res = core.query(term, { limit: 8 });
        window.SMKSearch.track(term, res.total);
        var sugg = suggestionsHtml(window.SMKSearchCore.suggest(term, self.smkPopular || [], res.items, 5), i18n);
        if (!res.total) return sugg + '<div class="d-block w-100 ta-center color-light no-result-message' + (sugg ? ' smk-no-result--inline' : ' p-absolute center-middle') + '">' + escapeHtml(i18n.no_matching_results || 'No matching result found') + '</div>';
        var handles = res.items.map(function (i) { return i.h; });
        return window.SMKSearch.fetchCards(window.SMKSearch.cardsQuery('p', term, handles)).then(function (html) { return sugg + noticeHtml(res, i18n) + html; });
      }).catch(function (e) {
        if (window.console) console.warn('[smk-search] predictive fallback:', e);
        return nativeFetch.call(self, term);
      });
    };

    // Empty-state suggestions (popular + recent) replace the "Enter keywords" text.
    var els = document.querySelectorAll('sht-predictive-srch');
    Array.prototype.forEach.call(els, function (el) {
      var input = el.querySelector('.js-predictive-search-input');
      var placeholder = el.querySelector('.js-predictive-search-message-placeholder');
      var form = el.querySelector('.js-predictive-search-form');
      var i18n = readI18n(el);
      var popular = [];
      var termsUrl = el.getAttribute('data-smk-terms-url');
      if (!input || !placeholder) return;

      function render() {
        positionPanel(el);
        var recent = readRecent();
        var html = '';
        if (recent.length) html += chipsHtml(i18n.recent_searches || 'Recent searches', recent, ' <button type="button" class="smk-suggest__clear" data-smk-clear-recent>' + escapeHtml(i18n.clear_recent || 'Clear') + '</button>');
        html += chipsHtml(i18n.popular_searches || 'Popular searches', popular.slice(0, 8));
        if (!html) return; // keep the theme's original text
        placeholder.classList.add('smk-has-suggest');
        placeholder.innerHTML = '<div class="smk-suggest">' + html + '</div>';
      }
      function warm() { window.SMKSearch.ready().catch(function () {}); }

      input.addEventListener('focus', warm, { passive: true });
      input.addEventListener('focus', render, { passive: true });
      if (termsUrl) {
        fetch(termsUrl).then(function (r) { return r.ok ? r.json() : []; }).then(function (list) { popular = Array.isArray(list) ? list : []; el.smkPopular = popular; render(); }).catch(function () {});
      }
      el.addEventListener('click', function (ev) {
        var chip = ev.target.closest('[data-smk-term]');
        if (chip) {
          ev.preventDefault();
          input.value = chip.getAttribute('data-smk-term');
          pushRecent(input.value);
          input.focus();
          input.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }
        if (ev.target.closest('[data-smk-clear-recent]')) { ev.preventDefault(); clearRecent(); render(); }
      });
      if (form) form.addEventListener('submit', function () { pushRecent(input.value); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupPredictive);
  else setupPredictive();

  // ---------- Results page (/search) ----------
  var PAGE_SIZE = 16;
  var FACET_GROUPS = [ // metafield facets in the same order as the collection sidebar
    ['cam_number', 'Number of Cameras'], ['resolution', 'Resolution'], ['nightvision', 'NightVision'],
    ['audio', 'Audio'], ['active_deterrence', 'Active Deterrence'], ['ip_rating', 'IP Rating']
  ];
  var ICON_CHECK = '<svg class="input__checkbox__icon mr-12 field--hover checkbox--hover" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.14648 15.0711L18.9247 5.29291L20.3389 6.70712L9.14648 17.8995L3.66119 12.4142L5.07541 11L9.14648 15.0711Z"/></svg>';
  var ICON_CHEVRON = '<span class="btn btn-small btn-icon"><svg class="open icon-chevron-down p-absolute" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.7071 9.00421L18.2929 7.59L12 13.8829L5.70712 7.59L4.29291 9.00421L12 16.7113L19.7071 9.00421Z"/></svg></span>';
  var ICON_CLOSE = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" class="ml-8" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.6569 19.0711L4.92893 6.34314L6.34315 4.92892L19.0711 17.6568L17.6569 19.0711Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.92893 17.6568L17.6569 4.92892L19.0711 6.34314L6.34315 19.0711L4.92893 17.6568Z"/></svg>';
  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('en-AU'); }
  function bucketLabel(b) {
    var p = b.split('-'); var lo = +p[0], hi = p[1] === '' ? null : +p[1];
    return hi == null ? money(lo) + '+' : money(lo) + ' – ' + money(hi);
  }

  function setupResults() {
    var root = document.querySelector('sht-srch');
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    var q = (params.get('q') || '').trim();
    if (!q || q.indexOf('__h__:') === 0) return;
    var grid = document.getElementById('collectionProductGrid');
    var container = document.getElementById('mainSearchContainer');
    if (!grid || !container) return;
    var i18n = readI18n(root);
    var wmd = grid.getAttribute('data-w-md') || '3', wxs = grid.getAttribute('data-w-xs') || '6';
    var drawerBody = root.querySelector('.js-main-search-drawer-body');
    var headerLeft = root.querySelector('.filter-products-header--left');
    var headerRight = root.querySelector('.collection-product-header--right');

    var state = parseState(params.get('smk'));
    var openGroups = { price: true, vendor: true };
    var shown = 0, current = null, core = null, layout = null;
    var loadSequence = 0, cardsLoading = false;
    var mq = window.matchMedia('(max-width: 768px)');

    function emptyState() { return { vendor: [], type: [], inStock: true, price: [], priceMin: null, priceMax: null, f: {}, sort: 'relevance' }; }
    function parseState(s) {
      var st = emptyState();
      if (!s) return st;
      s.split(';').forEach(function (part) {
        var i = part.indexOf(':'); if (i === -1) return;
        var k = part.slice(0, i), v = part.slice(i + 1);
        var list = v ? v.split(',').map(decodeURIComponent) : [];
        if (k === 'v') st.vendor = list;
        else if (k === 'y') st.type = list;
        else if (k === 'a') st.inStock = v === '1';
        else if (k === 'p') st.price = list;
        else if (k === 'pmin') st.priceMin = +v || null;
        else if (k === 'pmax') st.priceMax = +v || null;
        else if (k === 's' && v) st.sort = v;
        else if (k.indexOf('f.') === 0) st.f[k.slice(2)] = list;
      });
      return st;
    }
    function serialiseState() {
      var parts = [], enc = function (l) { return l.map(encodeURIComponent).join(','); };
      if (state.vendor.length) parts.push('v:' + enc(state.vendor));
      if (state.type.length) parts.push('y:' + enc(state.type));
      if (state.inStock) parts.push('a:1');
      if (state.price.length) parts.push('p:' + enc(state.price));
      if (state.priceMin != null) parts.push('pmin:' + state.priceMin);
      if (state.priceMax != null) parts.push('pmax:' + state.priceMax);
      for (var k in state.f) if (state.f[k] && state.f[k].length) parts.push('f.' + k + ':' + enc(state.f[k]));
      if (state.sort !== 'relevance') parts.push('s:' + state.sort);
      return parts.join(';');
    }
    function syncUrl() {
      var u = new URL(window.location.href), s = serialiseState();
      if (s) u.searchParams.set('smk', s); else u.searchParams.delete('smk');
      window.history.replaceState(null, '', u.toString());
    }
    function filtersForQuery() { return { vendor: state.vendor, type: state.type, inStock: state.inStock, price: state.price, priceMin: state.priceMin, priceMax: state.priceMax, f: state.f }; }
    function hide(sel) { Array.prototype.forEach.call(root.querySelectorAll(sel), function (el) { el.classList.add('smk-hidden'); }); }
    function setHidden(el, on) { if (el) el.classList.toggle('smk-hidden', !!on); }
    function entries(obj, n) {
      return Object.keys(obj).filter(Boolean).map(function (k) { return [k, obj[k]]; }).sort(function (a, b) { return b[1] - a[1] || a[0].localeCompare(b[0]); }).slice(0, n || 50);
    }
    function idFor(group, value) { return 'smkf-' + (group + '-' + value).replace(/[^a-z0-9]+/gi, '-').toLowerCase(); }
    function checkbox(group, value, label, count, on) {
      var id = idFor(group, value);
      return '<li class="filter-form__item pt-8 pb-8"><span class="field__checkbox d-flex middle-xs c-pointer">' +
        '<input type="checkbox" class="input__checkbox p-absolute opacity-0" id="' + id + '" data-smk-group="' + escapeHtml(group) + '" data-smk-value="' + escapeHtml(value) + '"' + (on ? ' checked' : '') + '>' +
        ICON_CHECK + '<label for="' + id + '" class="flex-1 wb-break-word">' + escapeHtml(label) + (count != null ? ' (' + count + ')' : '') + '</label></span></li>';
    }
    function group(key, title, itemsHtml, extraHtml) {
      if (!itemsHtml && !extraHtml) return '';
      return '<details class="filter-form__details smk-group" data-smk-key="' + key + '"' + (openGroups[key] ? ' open' : '') + '>' +
        '<summary class="filter-form__summary p-relative d-flex middle-xs between-xs ls-none c-pointer">' + escapeHtml(title) + ICON_CHEVRON + '</summary>' +
        '<div class="filter-form__display">' + (itemsHtml ? '<ul class="filter-form__items r-gap-8 between-xs d-grid ls-none">' + itemsHtml + '</ul>' : '') + (extraHtml || '') + '</div></details>';
    }
    function isOn(group, value) {
      if (group === 'available') return state.inStock;
      if (group === 'vendor') return state.vendor.indexOf(value) !== -1;
      if (group === 'type') return state.type.indexOf(value) !== -1;
      if (group === 'price') return state.price.indexOf(value) !== -1;
      return (state.f[group] || []).indexOf(value) !== -1;
    }
    function toggle(group, value) {
      if (group === 'available') { state.inStock = !state.inStock; return; }
      var list = group === 'vendor' ? state.vendor : group === 'type' ? state.type : group === 'price' ? state.price : (state.f[group] = state.f[group] || []);
      var i = list.indexOf(value); if (i === -1) list.push(value); else list.splice(i, 1);
    }
    function renderSidebar(res) {
      if (!drawerBody) return;
      var html = '<div class="filter-form smk-sidebar">';
      var priceItems = window.SMKSearchCore.PRICE_BUCKETS.filter(function (b) { return res.facets.price[b]; }).map(function (b) { return checkbox('price', b, bucketLabel(b), res.facets.price[b], isOn('price', b)); }).join('');
      html += group('price', i18n.price || 'Price', priceItems);
      html += group('vendor', i18n.brand || 'Brand', entries(res.facets.vendor).map(function (e) { return checkbox('vendor', e[0], e[0], e[1], isOn('vendor', e[0])); }).join(''));
      html += group('type', i18n.product_type || 'Product type', entries(res.facets.type).map(function (e) { return checkbox('type', e[0], e[0], e[1], isOn('type', e[0])); }).join(''));
      FACET_GROUPS.forEach(function (g) {
        var vals = res.facets.f[g[0]]; if (!vals) return;
        html += group(g[0], g[1], entries(vals).map(function (e) { return checkbox(g[0], e[0], e[0], e[1], isOn(g[0], e[0])); }).join(''));
      });
      html += '</div>';
      drawerBody.innerHTML = html;
    }
    function activeTags() {
      var tags = [];
      if (state.inStock) tags.push(['available', '1', i18n.only_in_stock || 'In stock only']);
      state.price.forEach(function (b) { tags.push(['price', b, bucketLabel(b)]); });
      if (state.priceMin != null || state.priceMax != null) tags.push(['pricerange', '', (state.priceMin != null ? money(state.priceMin) : money(0)) + ' – ' + (state.priceMax != null ? money(state.priceMax) : '∞')]);
      state.vendor.forEach(function (v) { tags.push(['vendor', v, v]); });
      state.type.forEach(function (v) { tags.push(['type', v, v]); });
      for (var k in state.f) (state.f[k] || []).forEach(function (v) { tags.push([k, v, v]); });
      return tags;
    }
    function renderActive() {
      var bar = document.getElementById('smkActive');
      if (!bar) { bar = document.createElement('div'); bar.id = 'smkActive'; bar.className = 'smk-active-filters filter-form__active-filters filter-tags gap-12 d-flex fw-wrap'; container.insertBefore(bar, container.querySelector('.results')); }
      var tags = activeTags();
      setHidden(bar, !tags.length);
      bar.innerHTML = tags.map(function (t) {
        return '<button type="button" class="tag tag-close d-inline-flex middle-xs smk-tag" data-smk-group="' + escapeHtml(t[0]) + '" data-smk-value="' + escapeHtml(t[1]) + '"><span class="wb-break-word flex-1">' + escapeHtml(t[2]) + '</span>' + ICON_CLOSE + '</button>';
      }).join('') + (tags.length ? '<button type="button" class="btn btn-link btn--medium smk-clear-all" data-smk-clear>' + escapeHtml(i18n.clear_all || 'Clear all') + '</button>' : '');
    }
    function renderHeader(res) {
      var countEl = document.getElementById('smkCount');
      if (!countEl) {
        countEl = document.createElement('p'); countEl.id = 'smkCount'; countEl.className = 'smk-count fs-body fw-700 m-zero'; countEl.setAttribute('role', 'status'); countEl.setAttribute('aria-live', 'polite');
        (headerLeft || container).insertBefore(countEl, (headerLeft || container).firstChild);
      }
      countEl.textContent = (i18n.showing_count || 'Showing %c results for "%s"').replace('%c', res.total).replace('%s', q);
      if (!document.getElementById('smkSort')) {
        var sorts = [['relevance', i18n.sort_relevance || 'Relevance'], ['price-asc', i18n.sort_price_asc || 'Price, low to high'], ['price-desc', i18n.sort_price_desc || 'Price, high to low'], ['title-asc', i18n.sort_title_asc || 'Alphabetically, A-Z']];
        var wrap = document.createElement('div'); wrap.className = 'smk-filters__sort';
        wrap.innerHTML = '<label class="visually-hidden" for="smkSort">' + escapeHtml(i18n.sort_by || 'Sort by') + '</label><select id="smkSort" class="smk-sort">' + sorts.map(function (s) { return '<option value="' + s[0] + '"' + (state.sort === s[0] ? ' selected' : '') + '>' + escapeHtml(s[1]) + '</option>'; }).join('') + '</select>';
        (headerRight || container).appendChild(wrap);
        wrap.querySelector('#smkSort').addEventListener('change', function (ev) { state.sort = ev.target.value; syncUrl(); loadPage(true); });
      }
      var tab = root.querySelector('.js-main-search-product-tab a');
      if (tab) tab.textContent = (i18n.products || 'Products') + ' (' + res.total + ')';
      var note = document.getElementById('smkNotice');
      var text = res.typo.length ? (i18n.showing_results_for || 'Showing results for "%s"').replace('%s', res.typo.map(function (t) { return t.to; }).join(' ')) : (res.partial ? (i18n.no_exact_match || '') : '');
      if (!note) { note = document.createElement('p'); note.id = 'smkNotice'; note.className = 'smk-notice'; container.insertBefore(note, container.querySelector('.results')); }
      note.textContent = text; setHidden(note, !text);
    }
    function renderLoadMore(res) {
      var btn = document.getElementById('smkLoadMore');
      if (!btn) {
        var wrap = document.createElement('div'); wrap.className = 'smk-load-more';
        wrap.innerHTML = '<button type="button" id="smkLoadMore" class="btn btn-secondary btn-large">' + escapeHtml(i18n.load_more || 'Load more') + '</button>';
        grid.parentNode.insertBefore(wrap, grid.nextSibling);
        btn = wrap.firstChild;
        btn.addEventListener('click', function () { loadPage(false); });
      }
      setHidden(btn.parentNode, shown >= res.total);
    }
    function loadPage(reset) {
      if (!reset && cardsLoading) return;
      var thisLoad = ++loadSequence;
      cardsLoading = false;
      var oldError = document.getElementById('smkCardsError'); if (oldError) oldError.remove();
      if (reset) { shown = 0; grid.innerHTML = ''; }
      layout = mq.matches ? 'm' : 'd';
      grid.classList.remove('smk-grid--m', 'smk-grid--d'); grid.classList.add('smk-grid', 'smk-grid--' + layout);
      current = core.query(q, { limit: PAGE_SIZE, offset: shown, sort: state.sort, filters: filtersForQuery() });
      renderHeader(current); renderActive();
      var emptyMsg = root.querySelector('.results-empty');
      setHidden(emptyMsg, current.total > 0);
      if (!current.items.length) {
        if (!current.total && !emptyMsg) {
          var p = document.createElement('p'); p.className = 'ta-center results-empty'; p.setAttribute('role', 'status');
          p.innerHTML = (i18n.no_match_html || 'No results found for "%s".').replace('%s', escapeHtml(q));
          grid.parentNode.insertBefore(p, grid);
        }
        renderLoadMore(current); return;
      }
      var handles = current.items.map(function (i) { return i.h; });
      cardsLoading = true;
      var btn = document.getElementById('smkLoadMore'); if (btn) btn.disabled = true;
      window.SMKSearch.fetchCards(window.SMKSearch.cardsQuery('r', q, handles, wmd, wxs, layout)).then(function (html) {
        if (thisLoad !== loadSequence) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        if (parsed.querySelectorAll('.js-main-search-result-product').length !== handles.length) throw new Error('Incomplete search cards response');
        cardsLoading = false;
        grid.insertAdjacentHTML('beforeend', html);
        shown += handles.length;
        renderLoadMore(current);
        if (btn) btn.disabled = false;
      }).catch(function (e) {
        if (thisLoad !== loadSequence) return;
        cardsLoading = false;
        var error = document.createElement('p'); error.id = 'smkCardsError'; error.setAttribute('role', 'status');
        error.textContent = "We couldn't load the products. ";
        var retry = document.createElement('button'); retry.type = 'button'; retry.textContent = 'Try again';
        retry.addEventListener('click', function(){ loadPage(false); }); error.appendChild(retry); grid.parentNode.insertBefore(error, grid.nextSibling);
        if (window.console) console.warn('[smk-search] results cards failed:', e);
        if (btn) btn.disabled = false;
      });
    }
    function applyChange() { syncUrl(); renderSidebar(core.query(q, { limit: 0 })); renderActive(); loadPage(true); }

    window.SMKSearch.ready().then(function (c) {
      core = c;
      var first = core.query(q, { limit: 0 });
      hide('.filter-form-sorting, .filter-form__result-count, .js-active-filters, .s-footer, sht-srch-fltr-frm');
      renderSidebar(first);
      window.SMKSearch.track(q, first.total);
      loadPage(true);

      // Sidebar checkboxes + price range (the drawer body is re-rendered, so delegate).
      if (drawerBody) {
        drawerBody.addEventListener('change', function (ev) {
          var cb = ev.target.closest('input[data-smk-group]'); if (!cb) return;
          toggle(cb.getAttribute('data-smk-group'), cb.getAttribute('data-smk-value')); applyChange();
        });
        drawerBody.addEventListener('toggle', function (ev) { var d = ev.target; if (d.matches && d.matches('details[data-smk-key]')) openGroups[d.getAttribute('data-smk-key')] = d.open; }, true);
      }
      // The theme's drawer footer buttons call its own AJAX filter form; take them over.
      var drawer = root.querySelector('.js-main-search-drawer');
      if (drawer) drawer.addEventListener('click', function (ev) {
        var clear = ev.target.closest('.js-main-search-clear-all-btn'), done = ev.target.closest('.js-main-search-done-btn');
        if (!clear && !done) return;
        ev.preventDefault(); ev.stopPropagation();
        if (clear) { var keepSort = state.sort; state = emptyState(); state.sort = keepSort; applyChange(); }
        if (done && typeof drawer.closeDrawer === 'function') drawer.closeDrawer();
      }, true);
      // Active filter tags.
      document.getElementById('smkActive').addEventListener('click', function (ev) {
        var clr = ev.target.closest('[data-smk-clear]'), tag = ev.target.closest('.smk-tag');
        if (clr) { var ks = state.sort; state = emptyState(); state.sort = ks; applyChange(); return; }
        if (!tag) return;
        var g = tag.getAttribute('data-smk-group'), v = tag.getAttribute('data-smk-value');
        if (g === 'pricerange') { state.priceMin = null; state.priceMax = null; } else toggle(g, v);
        applyChange();
      });
      // Crossing the phone breakpoint switches card layout; re-render once.
      var onMq = function () { if (core && layout && (mq.matches ? 'm' : 'd') !== layout) loadPage(true); };
      if (mq.addEventListener) mq.addEventListener('change', onMq); else mq.addListener(onMq);
    }).catch(function (e) { if (window.console) console.warn('[smk-search] results page left native:', e); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupResults);
  else setupResults();
})();
